<template>
  <div class="container">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/inicio">Início</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/noticias">Notícias</a>
                </li>
                <li class="breadcrumb-item">
                  <a style="color: grey; hover: none">Cadastrar Notícia</a>
                </li>
              </ol>
              <h3 style="color: #000; margin-left: 15px">Cadastrar Notícia</h3>
            </nav>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <label>Título da Notícia</label>
          <input
            type="text"
            class="form-control"
            v-model="state.titulo.value"
            placeholder="Insira o título da notícia"
            maxlength="150"
          />
          <span v-if="state.titulo.error" class="text-danger"
            >Este campo é obrigatório</span
          >
        </div>
        <div class="col-12">
          <label>Url da Notícia</label>
          <input
            type="text"
            class="form-control"
            v-model="state.titulo_url.value"
            placeholder="Insira o tiítulo que irá aparecer na url da página"
            maxlength="150"
          />
          <span v-if="state.titulo_url.error" class="text-danger"
            >Este campo é obrigatório</span
          >
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Subtítulo</label>
            <input
              class="form-control"
              type="text"
              id="descricao"
              v-model="state.subtitulo.value"
              maxlength="255"
              placeholder="Insira o subtítulo da notícia"
            />
            <span v-if="state.subtitulo.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="input_img">
          <label>Imagem</label>
          <input type="file" class="form-control" @change="adicionarImagens" />
          <span v-if="state.erro_imagem" class="text-danger"
            >Este campo é obrigatório</span
          >
        </div>
      </div>
      <div class="col-md-12" v-if="state.imagens.length > 0">
        <div class="row">
          <div
            class="col-md-4"
            v-for="(objImagem, index) in state.imagens"
            :key="objImagem"
            style="display: flex"
          >
            <img :src="objImagem.imagem" class="imagem" />
            <button class="btn_deletar_imagem" @click="removerImagem(index)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                fill="currentColor"
                class="bi bi-x-lg mb-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <label for="texto">Texto da Notícia</label>
          <div class="form-group">
            <editor
              api-key="8rtof9gqqepz37q7viy6i1vme2tv702kdqv8sd5ra7fjr1tr"
              :init="{
                height: 500,
                menubar: false,
                selector: 'textarea',
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
              }"
              v-model="state.texto"
            />
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-2">
          <div class="form-group">
            <label>Status</label>
            <select class="form-select" v-model="state.status">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
        <div class="col-2">
          <label for="destaque1">Destaque 1</label>
          <select id="destaque1" v-model="state.destaque1" class="form-select">
            <option value="SIM">Sim</option>
            <option value="NAO">Não</option>
          </select>
        </div>
        <div class="col-2">
          <label for="destaque2">Destaque 2</label>
          <select id="destaque2" v-model="state.destaque2" class="form-select">
            <option value="SIM">Sim</option>
            <option value="NAO">Não</option>
          </select>
        </div>
        <div class="col-3">
          <label for="tag">Categoria</label>
          <select class="form-select" v-model="state.categoria_id.value">
            <option
              v-for="categoria in state.categorias"
              :key="categoria.id"
              :value="categoria.id"
            >
              {{ categoria.titulo }}
            </option>
          </select>
          <span v-if="state.categoria_id.error" class="text-danger"
            >Este campo é obrigatório</span
          >
        </div>
        <div class="col-3">
          <div class="form-group">
            <label>TAG Principal</label>
            <input
              class="form-control"
              type="text"
              id="descricao"
              v-model="state.tag_principal.value"
            />
            <span v-if="state.tag_principal.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-8">
          <label for="link">Link para Vídeo do youtube</label>
          <input
            type="text"
            id="link"
            class="form-control"
            placeholder="Cole aqui o link para o vídeo"
            maxlength="60"
            v-model="state.link_youtube"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-auto">
          <button
            class="btn btn_voltar btn-secondary me-3"
            id="voltar-button"
            type="submit"
            @click="router.push({ name: 'noticias' })"
          >
            Voltar
          </button>
          <button
            class="btn btn_salvar float-end"
            id="submit-button"
            type="submit"
            @click="salvarNoticia()"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
import Editor from "@tinymce/tinymce-vue";
export default {
  components: {
    editor: Editor,
  },
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      categoria_id: {
        value: "",
        error: false,
      },
      titulo: {
        value: "",
        error: false,
      },
      titulo_url: {
        value: "",
        error: false,
      },
      subtitulo: {
        value: "",
        error: false,
      },
      texto: "",
      status: "ATIVO",
      destaque1: "NAO",
      destaque2: "NAO",
      tag_principal: {
        value: "",
        error: false,
      },
      link_youtube: "",
      categorias: [],
      imagem: {},
      imagens: [],
      erro_imagem: false,
      imagens_deletar: [],
      notichaImg: [],
    });

    onMounted(() => {
      fetchCategoria();
      if (router.currentRoute._value.params.id != undefined) {
        fetchNoticia();
      }
    });

    async function fetchNoticia() {
      try {
        const { data } = await services.noticia.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.categoria_id.value = data.categoria_id;
        state.titulo.value = data.titulo;
        state.titulo_url.value = data.titulo_url;
        state.subtitulo.value = data.subtitulo;
        state.texto = data.texto;
        state.status = data.status;
        state.destaque1 = data.destaque1;
        state.destaque2 = data.destaque2;
        state.tag_principal.value = data.tag_principal;
        state.link_youtube = data.link_youtube;
        state.imagens = data.imagens;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchCategoria() {
      try {
        const { data } = await services.categoria.getAll({ token });
        state.categorias = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarNoticia() {
      var erro_validacao = false;

      if (state.titulo.value.length == 0) {
        state.titulo.error = true;
        erro_validacao = true;
      }
      if (state.titulo_url.value.length == 0) {
        state.titulo_url.error = true;
        erro_validacao = true;
      }
      if (state.subtitulo.value.length == 0) {
        state.subtitulo.error = true;
        erro_validacao = true;
      }
      if (state.categoria_id.value.length == 0) {
        state.categoria_id.error = true;
        erro_validacao = true;
      }

      if (state.tag_principal.value.length == 0) {
        state.tag_principal.error = true;
        erro_validacao = true;
      }
      if (state.imagens.length == 0) {
        state.erro_imagem = true;
        erro_validacao = true;
      }
      if (erro_validacao == true) {
        return;
      }

      var noticia = {};
      noticia.titulo = state.titulo.value;
      noticia.categoria_id = state.categoria_id.value;
      noticia.titulo_url = state.titulo_url.value;
      noticia.subtitulo = state.subtitulo.value;
      noticia.texto = state.texto;
      noticia.status = state.status;
      noticia.destaque1 = state.destaque1;
      noticia.destaque2 = state.destaque2;
      noticia.tag_principal = state.tag_principal.value;
      noticia.link_youtube = state.link_youtube;

      if (!state.id) {
        services.noticia
          .save({ token, noticia })
          .then((data_noticia) => {
            for (let i = 0; i < state.imagens.length; i++) {
              var formImagem = new FormData();
              formImagem.append("noticia_id", data_noticia.data.id);
              formImagem.append("imagem", state.imagens[i].file);
              services.noticia
                .salvarImagem({ token, formImagem })
                .then((data) => {
                  console.log(data);
                });
            }
            router.push({ name: "noticias" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            valores.forEach((element) => {
              element.forEach((element2) => {
                alert(element2);
              });
            });
          });
      } else {
        console.log(
          "Qtd de imagens para deletar: " + state.imagens_deletar.length
        );
        if (state.imagens_deletar.length > 0) {
          try {
            const { data } = await services.noticia.deletarImagens({
              imagens: state.imagens_deletar,
              token,
            });
            console.log(data);
          } catch (error) {
            console.log(error);
          }
        }
        noticia.id = state.id;
        services.noticia
          .update({ token, noticia })
          .then((data_noticia) => {
            for (let i = 0; i < state.imagens.length; i++) {
              if (
                state.imagens[i].file != undefined &&
                state.imagens[i].file != null
              ) {
                var formImagem = new FormData();
                formImagem.append("noticia_id", data_noticia.data.id);
                formImagem.append("imagem", state.imagens[i].file);
                services.noticia
                  .salvarImagem({ token, formImagem })
                  .then((data) => {
                    console.log(data);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            }
            router.push({ name: "noticias" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            valores.forEach((element) => {
              element.forEach((element2) => {
                alert(element2)
              });
            });
          });
      }
    }
    async function adicionarImagens(event) {
      for (let index = 0; index < event.target.files.length; index++) {
        const element = event.target.files[index];
        var objImagem = new Object();
        objImagem.id = index + 1;
        objImagem.file = element;
        objImagem.imagem = URL.createObjectURL(element);
        state.imagens.push(objImagem);
        console.log(objImagem);
      }
    }
    async function removerImagem(index_imagem) {
      //  console.log(state.imagens[index_imagem].id);
      if (state.imagens[index_imagem].id != undefined) {
        state.imagens_deletar.push(state.imagens[index_imagem].id);
      }
      state.imagens.splice(index_imagem, 1);
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      salvarNoticia,
      adicionarImagens,
      removerImagem,
      router,
      state,
    };
  },
};
</script> 

<style scoped lang="scss">
.card {
  min-height: 94.8vh;
}
.editor_texto {
}
.btn_editor {
  background: transparent;
  border: solid 2px #000;
  border-radius: 5px;
  margin: 5px;
}
.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}
#texto {
  resize: none;
}
label {
  font-size: 12pt;
  color: #000;
  margin-bottom: 0;
}
input {
  outline: none;
  font-size: 12pt;
  color: #000 !important;
}
select {
  outline: none !important;
  font-size: 12pt;
  color: #000 !important;
}
textarea {
  font-size: 12pt;
  color: #000 !important;
}
.btn_salvar:hover {
  color: #fff;
}
.input_img {
  margin-bottom: 20px;
}
.btn_deletar_imagem {
  width: 25px;
  height: 25px;
  margin-right: 50px;
  background: rgb(170, 0, 0);
  color: #fff;
  border: solid 1px rgb(170, 0, 0);
  border-radius: 5px;
  margin-left: 5px;
  transition: 0.3s;
}
.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}
.imagem {
  height: auto;
  width: 300px;
  margin-bottom: 1rem;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
label {
  font-size: 14pt;
  color: #000;
  margin-bottom: 0;
}
input {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
input:focus {
  border: solid 1px blue;
}
select {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
select:focus {
  border: solid 1px blue;
}
</style>

<style lang="scss">
/* Basic editor styles */

.ProseMirror {
  margin-top: 10px;
  border: solid 2px #000;
  padding: 10px;
  border-radius: 10px;
  color: #616161;
  min-height: 300px;
  > * + * {
    margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  pre {
    background: #0d0d0d;
    color: #fff;
    font-family: "JetBrainsMono", monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.1);
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0d0d0d, 0.1);
    margin: 2rem 0;
  }
}
.ProseMirror {
  outline: 0;
}
</style>